'use client';

import { useRouter, useSearchParams, usePathname } from 'next/navigation';
import { useEffect, useState, useTransition } from 'react';

export default function SearchBar() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const urlQuery = searchParams?.get('q') || '';
  const [value, setValue] = useState(urlQuery);
  const [isPending, startTransition] = useTransition();

  // Sync input с URL: клик по хэштегу/внешняя навигация меняет ?q=... →
  // input подхватывает значение, и появляется ✕ для сброса.
  useEffect(() => {
    setValue(urlQuery);
  }, [urlQuery]);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const params = new URLSearchParams(searchParams?.toString() ?? '');
    if (value.trim()) {
      params.set('q', value.trim());
    } else {
      params.delete('q');
    }
    params.delete('page');
    startTransition(() => {
      router.push(`${pathname}?${params.toString()}`);
    });
  }

  function handleClear() {
    setValue('');
    const params = new URLSearchParams(searchParams?.toString() ?? '');
    params.delete('q');
    params.delete('page');
    startTransition(() => {
      router.push(`${pathname}?${params.toString()}`);
    });
  }

  return (
    <form onSubmit={handleSubmit} className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-secondary" aria-hidden="true">🔍</span>
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Поиск в каталоге..."
        className="w-full bg-surface border border-line rounded-xl pl-9 pr-10 py-2.5 text-sm text-primary placeholder:text-secondary focus:outline-none focus:border-accent transition-colors"
      />
      <div className="absolute right-3 top-1/2 -translate-y-1/2" aria-live="polite">
        {isPending ? (
          <svg className="w-4 h-4 animate-spin text-secondary" viewBox="0 0 24 24" fill="none" aria-label="Идёт поиск">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
          </svg>
        ) : value ? (
          <button
            type="button"
            onClick={handleClear}
            aria-label="Очистить поиск"
            className="text-secondary hover:text-primary transition-colors text-xs"
          >
            ✕
          </button>
        ) : null}
      </div>
    </form>
  );
}
